/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {AbstractTransformConf} from './abstractTransformConf';
import {FieldTable} from './fieldTable';

export interface ConvertTypeTransformConf extends AbstractTransformConf {
    type?: ConvertTypeTransformConf.TypeEnum;
    category?: FieldTable.CategoryFieldEnum;
    pattern?: string;
    regex?: string;
    defaultValue?: string;
    localInput?: string;
    localOutput?: string;
    reverseSearch?: boolean;
    codeTraductionAiriane?: ConvertTypeTransformConf.CodeTraductionAirianeEnum;
    i18nGroup?: string;
    isConvertByDico?: boolean;
    srcConvert?: 'KEY' | 'VALUE';
}
export namespace ConvertTypeTransformConf {
    export type TypeEnum = 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID';
    export const TypeEnum = {
        String255: 'String255' as TypeEnum,
        String25: 'String25' as TypeEnum,
        String3: 'String3' as TypeEnum,
        String100: 'String100' as TypeEnum,
        String10: 'String10' as TypeEnum,
        String50: 'String50' as TypeEnum,
        TEXT: 'TEXT' as TypeEnum,
        Int: 'Int' as TypeEnum,
        BigInt: 'BigInt' as TypeEnum,
        Decimal52: 'Decimal_5_2' as TypeEnum,
        Decimal82: 'Decimal_8_2' as TypeEnum,
        Decimal112: 'Decimal_11_2' as TypeEnum,
        Boolean: 'Boolean' as TypeEnum,
        DateTime: 'DateTime' as TypeEnum,
        Date: 'Date' as TypeEnum,
        Time: 'Time' as TypeEnum,
        UUID: 'UUID' as TypeEnum
    };
    export type CodeTraductionAirianeEnum = 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT';
    export const CodeTraductionAirianeEnum = {
        AIRPLANE: 'AIRPLANE' as CodeTraductionAirianeEnum,
        AIRLINE: 'AIRLINE' as CodeTraductionAirianeEnum,
        AIRPORT: 'AIRPORT' as CodeTraductionAirianeEnum,
        CITY: 'CITY' as CodeTraductionAirianeEnum,
        TERRITORY: 'TERRITORY' as CodeTraductionAirianeEnum,
        COUNTRY: 'COUNTRY' as CodeTraductionAirianeEnum,
        CONTINENT: 'CONTINENT' as CodeTraductionAirianeEnum
    };
}
